import { ViewModel } from 'view_models/view_model'
import { Rack } from 'entities/rack'
import { Badge, OverlayTrigger, ProgressBar, Tooltip } from 'react-bootstrap'
import { ReactNode } from 'react'
import moment from 'moment'

export class RackViewModel extends ViewModel<Rack> {
    public expireDateText = (): string => {
        if (this.object.lastResultSentDate) {
            return this.toDateText(this.object.lastResultSentDate)
        } else {
            return '-'
        }
    }

    public isExpired = (): boolean => {
        if (!this.object.lastResultSentDate) {
            return false
        }
        const deadline = this.toDate(this.object.lastResultSentDate)
        if (!deadline) {
            return false
        }
        const today = moment()
        const diffDays = deadline.diff(today, 'days')
        return diffDays < 0
    }

    public expireDateView = (): ReactNode | undefined => {
        if (!this.object.expireDate) {
            return <div>-</div>
        }
        const deadline = this.toDate(this.object.lastResultSentDate)
        if (!deadline) {
            return
        }
        const today = moment()
        const diffDays = deadline.diff(today, 'days')
        const text = diffDays >= 0 ? `廃棄まで${diffDays}日` : `${Math.abs(diffDays)}日超過`
        let variant = 'light'
        if (diffDays <= 0) {
            variant = 'danger'
        } else if (diffDays < 10) {
            variant = 'warning'
        }
        return (
            <div style={{ width: '100%' }}>
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 0, hide: 0 }}
                    overlay={
                        <Tooltip id="expire-tooltip">
                            <div style={{ margin: 0 }}>{this.expireDateText()}に廃棄予定</div>
                        </Tooltip>
                    }
                >
                    <Badge bg={variant} text={variant === 'light' ? 'dark' : 'light'} style={{ width: '100%' }}>
                        {text}
                    </Badge>
                </OverlayTrigger>
            </div>
        )
    }

    public progressView = () => {
        if (this.object.rackType?.capacity && typeof this.object.tubeCount === 'number') {
            const progress = (this.object.tubeCount! / this.object.rackType.capacity) * 100
            return <ProgressBar variant="success" now={progress} style={{ height: 10, width: 100, margin: 0 }} />
        } else {
            return <div>-</div>
        }
    }
}
